import React from 'react';
import { X, RefreshCw, AlertCircle, CheckCircle, Info } from 'lucide-react';
import { useNotification } from '../lib/NotificationProvider';
import { cn } from '../lib/utils';

const Notification = () => {
  const { notification, clearNotification } = useNotification();

  if (!notification) return null;

  const { type, message, action } = notification;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case 'error':
        return <AlertCircle className="h-5 w-5 text-red-500" />;
      case 'info':
      default:
        return <Info className="h-5 w-5 text-accent-500" />;
    }
  };

  const getBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-50 border-green-200';
      case 'error':
        return 'bg-red-50 border-red-200';
      case 'info':
      default:
        return 'bg-accent-50 border-accent-200';
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-5 duration-300">
      <div
        className={cn(
          'flex items-center justify-between p-4 rounded-lg shadow-md border',
          getBgColor()
        )}
      >
        <div className="flex items-center space-x-3">
          {getIcon()}
          <span className="text-gray-800 font-medium">{message}</span>
        </div>
        <div className="flex items-center space-x-2 ml-8">
          {action && (
            <button
              onClick={action}
              className="p-1.5 rounded-md bg-white border border-gray-200 text-accent-600 hover:bg-accent-50 transition-colors"
              title="Refresh"
            >
              <RefreshCw className="h-4 w-4" />
            </button>
          )}
          <button
            onClick={clearNotification}
            className="p-1.5 rounded-md hover:bg-white/50 transition-colors"
            title="Dismiss"
          >
            <X className="h-4 w-4 text-gray-500" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notification;
